import axios from 'axios'
const BASE_API_URL = process.env.REACT_APP_API_URL

export const GET_EXPENSE_LIST = `${BASE_API_URL}/Expense/GeExpenseList`
export const CREATE_EXPENSE_LIST = `${BASE_API_URL}/Expense/AddExpenseDetails`
export const GET_EXPENSE_TYPE_DROPDOWN = `${BASE_API_URL}/Expense/GetExpenseTypeList`
export const GET_BUSINESS_TYPE_DROPDOWN = `${BASE_API_URL}/Expense/GetBTransTypeList`

export function getAllExpense() {
  return axios.get(GET_EXPENSE_LIST)
}

export function getExpenseTypeDropDown() {
  return axios.get(GET_EXPENSE_TYPE_DROPDOWN)
}

export function getTypeBusinessDropDown() {
  return axios.get(GET_BUSINESS_TYPE_DROPDOWN)
}

export function createExpense(
  bTransactTypeID: number,
  expenseTypeID: number,
  expenseTitle: string,
  descriptions: string,
  amount: number,
  transactionDate: string
) {
  return axios.post(CREATE_EXPENSE_LIST, {
    bTransactTypeID,
    expenseTypeID,
    expenseTitle,
    descriptions,
    amount,
    transactionDate,
  })
}
